module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/74c2f1a6834785b463915a2886026718.png";